import { useEffect, useState } from 'react';
import {
    Typography,
    Box,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';

function useTyping(text, speed = 50) {
    const [displayedText, setDisplayedText] = useState('');
    useEffect(() => {
        let i = 0;
        const timer = setInterval(() => {
            setDisplayedText(text.slice(0, i));
            i++;
            if (i > text.length) clearInterval(timer);
        }, speed);
        return () => clearInterval(timer);
    }, [text, speed]);
    return displayedText;
}

function Home() {
    const { t } = useTranslation();
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    const fullText = t('home.description');
    const typedText = useTyping(fullText, 30);

    return (
        <Box
            sx={{
                minHeight: '94.99vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'linear-gradient(-45deg, #1976d2, #1565c0, #0d47a1, #42a5f5)',
                backgroundSize: '400% 400%',
                animation: 'gradientAnimation 15s ease infinite',
                color: '#fff',
                '@keyframes gradientAnimation': {
                    '0%': { backgroundPosition: '0% 50%' },
                    '50%': { backgroundPosition: '100% 50%' },
                    '100%': { backgroundPosition: '0% 50%' },
                },
                padding: 2,
            }}
        >
            <Grid container spacing={4} alignItems="center" justifyContent="center">
                <Grid item xs={12} md={8} sx={{ textAlign: 'center' }}>
                    <Typography
                        variant={isSmall ? 'h4' : 'h2'}
                        fontWeight="bold"
                        gutterBottom
                    >
                        {t('home.title')}
                    </Typography>

                    <Box sx={{ position: 'relative', maxWidth: '700px', mx: 'auto' }}>
                        <Typography
                            variant="h6"
                            sx={{
                                visibility: 'hidden',
                                whiteSpace: 'pre-wrap',
                                fontFamily: "'Courier New', Courier, monospace",
                                fontSize: isSmall ? '1rem' : '1.25rem',
                            }}
                        >
                            {fullText}
                        </Typography>

                        <Typography
                            variant="h6"
                            sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                fontFamily: "'Courier New', Courier, monospace",
                                fontSize: isSmall ? '1rem' : '1.25rem',
                                whiteSpace: 'pre-wrap',
                            }}
                        >
                            {typedText}
                            <span
                                style={{
                                    borderRight: '2px solid white',
                                    marginLeft: 2,
                                    animation: 'blink 1s steps(2, start) infinite',
                                }}
                            />
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}

export default Home;
